import { Component, inject, OnInit } from '@angular/core';
import { CategoryService } from '../../Services/category.service';
import { NotificationService } from '../../Services/notification.service';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { couponrequest } from '../../models/Coupons/postCouponRequest.model';
import { CouponService } from '../../Services/coupon.service';
import { getCouponsResponse } from '../../models/Coupons/getCouponsResponse.model';

@Component({
  selector: 'app-page-add-coupon',
  templateUrl: './page-add-coupon.component.html',
  styleUrl: './page-add-coupon.component.scss',
})
export class PageAddCouponComponent implements OnInit {
  
  model: couponrequest;
  constructor(){
    this.model = {
      menuItemID: 0,
      couponCode: "",
      afterDiscountPrice: 0
    }
  }


  afterDiscountPrice?: number;
  categoryId = 0;
  categories: { nameEn: string; id: number }[] = [];
  menuItems: { nameEn: string; id: number }[] = [];
  resetDropdown: boolean = false;
  private categoryService = inject(CategoryService);
  private menuItemsService = inject(MenuItemsServiceService);
  private notificationService = inject(NotificationService);
  private couponService = inject(CouponService);

  ngOnInit(): void {
    this.loadCategories();
    this.loadCoupons();
  }

  onFormSubmit() {
    this.model.afterDiscountPrice = this.afterDiscountPrice ?? 0;
    this.couponService.sendCoupon(this.model).subscribe({
      next: (response) => {
        this.model.couponCode = "";
        this.model.afterDiscountPrice = 0;
        this.resetDropdown = true;
        this.loadCoupons();
        this.showSuccessAdd();
      },
      error: (err) => {
        //console.log("You Can't add Coupon for already existing Coupon");
        this.ErrorMessage();

      }
    })

  }

  onCategorySelect(id: number) {
    this.categoryId = id;
    this.loadMenuItems();
  }
  onMenuItemSelect(id: number) {
    this.model.menuItemID = id;
  }

  loadCategories() {
    this.categoryService.getAllCategories().subscribe({
      next: (data) => {
        this.categories = data.map((category) => ({
          nameEn: category.nameEn, // Adjust 'name' to the actual property name for category names
          id: category.id, // Adjust 'id' to the actual property name for category IDs
        }));

        this.loadMenuItems();
        //console.log('categories En', this.categories); // Log the whole data to see its structure
      },
      error: (err) => {
        this.showErrorMessage();
        //console.error('Error occurred while fetching categories:', err);
        if (err.error) {
          //console.error('Error details:', err.error);
        }
      },
    });
  }
  loadMenuItems() {
    this.menuItemsService.getAllItemByCategoryId(this.categoryId).subscribe({
      next: (data) => {
        this.menuItems = data.map((item) => ({
          nameEn: item.nameEn, // Adjust 'name' to the actual property name for category names
          id: item.id, // Adjust 'id' to the actual property name for category IDs
        }));

        //console.log('categories En', this.categories); // Log the whole data to see its structure
      },
      error: (err) => {
        this.showErrorMessage();
        //console.error('Error occurred while fetching categories:', err);
        if (err.error) {
          //console.error('Error details:', err.error);
        }
      },
    });
  }

  coupons: getCouponsResponse[] = [];

  loadCoupons(){
    this.couponService.getAllCoupons().subscribe({
      next: (response) => {
        console.log(response);
        this.coupons = response;
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  showErrorMessage() {
    this.notificationService.showMessage('Failed To Find items', 'danger');
  }

  ErrorMessage() {
    this.notificationService.showMessage("You Can't have two active coupons for the same menuItem", 'danger');
  }

  showErrorDelete() {
    this.notificationService.showMessage('Failed To Update Coupon Status', 'danger');
  }

  showSuccessAdd() {
    this.notificationService.showMessage(
      'Coupon Has Been added Successfully',
      'success'
    );
  }

}
